export default "__VITE_ASSET__2q2M$ewK__"